import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropdownMobileComponent } from './dropdown-mobile.component';
import { ClickOutsiteModule } from '../../directives/click-outsite/click-outsite.module';
import { IconModule } from '../icon/icon.module';
import { RouterModule } from '@angular/router';



@NgModule({
  imports: [
    CommonModule,
    ClickOutsiteModule,
    RouterModule,
    IconModule
  ],
  declarations: [ DropdownMobileComponent ],
  exports: [ DropdownMobileComponent ]
})
export class DropdownMobileModule { }
